export default __webpack_public_path__ + "static/media/stethoscope.419d899f.svg";